import { render, staticRenderFns } from "./teacher_login.vue?vue&type=template&id=1dc55cd2"
import script from "./teacher_login.vue?vue&type=script&lang=js"
export * from "./teacher_login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports